"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_focus_lock_1 = require("react-focus-lock");
var dialogBlueHeader_1 = require("spry-react/Dialog/dialogBlueHeader");
var dialogSimpleHeader_1 = require("spry-react/Dialog/dialogSimpleHeader");
var dialogSingleTab_1 = require("spry-react/Dialog/dialogSingleTab");
var spryDialogRoot_1 = require("spry-react/DialogPortal/spryDialogRoot");
require("./dialog.less");
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.header = function () {
            var header = _this.props.header;
            if (!header)
                return null;
            if (_this.isTwoLineHeader(header))
                return React.createElement(dialogBlueHeader_1.DialogBlueHeader, { line1: header.line1, line2: header.line2 });
            return React.createElement(dialogSimpleHeader_1.DialogSimpleHeader, { text: header });
        };
        return _this;
    }
    Dialog.prototype.render = function () {
        return React.createElement("div", { className: "l-dialog-container", style: { width: this.props.width || "75em" }, role: "dialog", "aria-modal": true },
            React.createElement("div", { className: "l-dialog", style: { position: "relative", display: "block", width: "100%" } },
                React.createElement(react_focus_lock_1.default, { returnFocus: true, whiteList: exports.shouldDialogFocusLockWhiteListNode },
                    this.header(),
                    this.props.singleTabText ? React.createElement(dialogSingleTab_1.DialogSingleTab, { text: this.props.singleTabText }) : null,
                    this.props.children)));
    };
    Dialog.prototype.isTwoLineHeader = function (header) {
        if (!header)
            return false;
        return typeof (header) !== 'string' && 'line1' in header;
    };
    return Dialog;
}(React.Component));
exports.Dialog = Dialog;
function SimpleDialog(props) {
    var close = props.close, children = props.children, dialogProps = __rest(props, ["close", "children"]);
    return React.createElement(Dialog, __assign({}, dialogProps),
        children,
        React.createElement("div", { className: "pure-g" },
            React.createElement("div", { className: "pure-u-1" },
                React.createElement("div", { className: "action-buttons l-box-vt-2x" },
                    React.createElement("button", { className: "pure-button pure-button-primary", onClick: close }, "Close")))));
}
exports.SimpleDialog = SimpleDialog;
/*
<FocusLock> is a focus manager.  It allows you to focus things inside the current active <FocusLock>, and will not allow you to focus things outside of the current active <FocusLock>.
This can be problematic if you have an active <FocusLock> on the page, and need to render something with focusable elements that is not nested in the current <FocusLock>, and cannot create its own <FocusLock>.
Examples:
1)  A Spry dialog opened from a Spry-React dialog
2)  A third-party modal (e.g. CBOSS)

The whitelist function provided to <FocusLock> determines if a node should be MANAGED by FocusLock.  That means:
  If a whitelisted node is inside the current active FocusLock, it can be focused.
  If a whitelisted node is outside the current active FocusLock, it cannot be focused.

Our default whitelist is:
  Anything rendered within our react '#root', excluding spry dialogs (which are rendered within #root, but cannot/should not be managed by FocusLock).

setShouldDialogFocusLockWhiteListNode is provided in case:
  Your react root element is different than '#root'.
  You do not have spry dialogs.
  You have other non-FocusLock-manageable elements rendered WITHIN your root.
*/
exports.shouldDialogFocusLockWhiteListNode = defaultShouldDialogFocusLockWhiteListNode;
function setShouldDialogFocusLockWhiteListNode(newShouldFocusLockWhiteListNode) {
    exports.shouldDialogFocusLockWhiteListNode = newShouldFocusLockWhiteListNode;
}
exports.setShouldDialogFocusLockWhiteListNode = setShouldDialogFocusLockWhiteListNode;
function defaultShouldDialogFocusLockWhiteListNode(node) {
    var _a, _b, _c;
    return _c = (((_a = document.getElementById('root')) === null || _a === void 0 ? void 0 : _a.contains(node)) && !((_b = document.getElementById(spryDialogRoot_1.SpryDialogRoot.DialogRootElementId)) === null || _b === void 0 ? void 0 : _b.contains(node))), (_c !== null && _c !== void 0 ? _c : false);
}
